module.exports = __webpack_public_path__ + "static/icon003572298c0dd55fa16bea13631a3788ecc.png";